import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { FeatureViewFCO, WorkspaceFCOContainer, FCOFields } from '../../../core/types/fcoTypes';
import { useGetDatasets } from '../../../api/datasets';
import { useGetFcos } from '../../../api/fcos';
import DataSetsList from '../dataSets/DatasetsList';
import { Empty, Loading } from '@lithos';

interface FeatureViewDatasetsProps {
  featureView: FeatureViewFCO;
}

const FeatureViewDatasets: FC<FeatureViewDatasetsProps> = ({ featureView }) => {
  const { workspace } = useParams();
  const {
    data: fcoData,
    isError: fcoError,
    isLoading: fcoLoading,
  } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  // eslint-disable-next-line prefer-const
  let { data: datasetsData, isLoading: datasetsIsLoading, error: dataSetsError } = useGetDatasets(workspace as string);

  if (datasetsIsLoading || dataSetsError) {
    return <Loading />;
  }

  if (dataSetsError || fcoError) {
    return (
      <Empty
        useCase="errorUnknown"
        title="Error loading datasets"
        description="We ran into an error loading the datasets."
        placement={'full-page'}
        actions={undefined}
      />
    );
  }

  const matchingDatasets = datasetsData?.data.filter((dataset) => {
    return dataset.featureViewId === featureView[FCOFields.ID];
  });

  return (
    <DataSetsList
      items={matchingDatasets ?? []}
      idToFcoMap={fcoData?.idToFcoMap ?? {}}
      workspace={workspace as string}
    />
  );
};

export default FeatureViewDatasets;
